import { render, staticRenderFns } from "./category.vue?vue&type=template&id=d59ffc8e&scoped=true"
import script from "./category.vue?vue&type=script&lang=js"
export * from "./category.vue?vue&type=script&lang=js"
import style0 from "./category.vue?vue&type=style&index=0&id=d59ffc8e&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../Desktop/sx_workspace/xsou-com/xsou-da-vue/h5/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d59ffc8e",
  null
  
)

export default component.exports